const logoSubtypes = [
  'LandscapeLogoMedia',
  'SquareLogoMedia',
  'TransparentLogo',
];

const smallSubtypes = [
  'ImagePRONG',
  'Windows11ProngLight',
];

const largeSubtypes = [
  'ImageSPOTLIGHT',
  'WindowsStoreSpotLight',
];

export const isLogo = subtype => logoSubtypes.includes(subtype);

export const isSmallImage = subtype => smallSubtypes.includes(subtype);

export const isLargeImage = subtype => largeSubtypes.includes(subtype);
